var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0C6.82596 0 7.29127 0.425595 7.29127 0.952381V4.98512L10.9195 2.99405C11.4141 2.72321 12.0519 2.86905 12.348 3.32143C12.6441 3.77381 12.4846 4.35714 11.99 4.62798L8.27398 6.66667L11.9933 8.70833C12.4879 8.97917 12.6473 9.5625 12.3512 10.0149C12.0551 10.4673 11.4173 10.6131 10.9227 10.3423L7.29127 8.34821V12.381C7.29127 12.9077 6.82596 13.3333 6.25 13.3333C5.67404 13.3333 5.20873 12.9077 5.20873 12.381V8.34821L1.58053 10.3393C1.08593 10.6101 0.448146 10.4643 0.152034 10.0119C-0.144079 9.55952 0.0153663 8.97619 0.509972 8.70536L4.22602 6.66667L0.506718 4.625C0.0121123 4.35417 -0.147333 3.77083 0.14878 3.31845C0.444892 2.86607 1.08267 2.72024 1.57728 2.99107L5.20873 4.98512V0.952381C5.20873 0.425595 5.67404 0 6.25 0Z",
    fill: "#D12E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitStar);
export default __webpack_public_path__ + "static/media/aitStar.eaa4f613d23ac7a1e55e6ebf4507e28d.svg";
export { ForwardRef as ReactComponent };